import { getPriceVisibility } from 'src/app/dataAnalytics/utils/getPriceVisibility';
import type { Tealium } from 'src/types/appState';

import { EVENT_VIEW_ROLE_REQS } from '../constants';

const getPurchaseType = (hirerType: string) =>
  hirerType.search('repeat') !== -1;

export const eventName = EVENT_VIEW_ROLE_REQS;

export default (tealium: Tealium) => {
  const {
    experiments,
    jobAdClassification,
    jobAdSubClassification,
    autoClassifyCategoryChosen,
    autoClassifyCategorySuggested,
    cajaPayType,
    cajaWorkType,
    recommendedSalaryRange,
    salaryRangeSelected,
    roleTitle,
    priceVisibility,
    isLinkOutApplyViaSeek,
    jobAdTypeSelected,
    hirerAdPurchaser,
    emailAddressVerified,
    previousPageName,
    productSetProductIds,
    productSetId,
  } = tealium;
  return {
    experiments,
    jobClassification: jobAdClassification,
    jobSubClassification: jobAdSubClassification,
    jobClassificationSelectedPosition: autoClassifyCategoryChosen,
    jobClassificationSuggestedCount: autoClassifyCategorySuggested,
    jobSalaryType: cajaPayType,
    jobWorkType: cajaWorkType,
    adSalaryrangeRecommended: recommendedSalaryRange,
    jobTitle: roleTitle,
    adSalaryRangeSelected: salaryRangeSelected,
    isPriceHidden: getPriceVisibility(priceVisibility),
    jobIsLinkout: Boolean(isLinkOutApplyViaSeek),
    adTypeSelected: jobAdTypeSelected,
    isHirerRepeatAdPurchaser: getPurchaseType(hirerAdPurchaser),
    isEmailUnverified: !emailAddressVerified,
    isEcajaStart: !previousPageName,
    productSetProductIds,
    adProductSetId: productSetId,
    adProductName: [jobAdTypeSelected],
  };
};
